import useAnalyticsActionEvents from "@stadium/services/analytics/hooks/use-action-events";
import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";
import { useWorkspaceContext } from "@stadium/hooks/lib/workspace";

import { getEventName } from "@stadium/helpers/analytics";
import { stopEventPropagation } from "@stadium/helpers/resource";
import { getCreateNewShopRoute } from "@stadium/helpers/app-routes";

import { USE_TEMPLATE } from "@constants/june-so";
import { JUNE_SO } from "@stadium/services/analytics/constants/services";
import Button from "@sharedComponents/buttons";

const UseTemplateCTA = ({
  className = "",
  pageName = "",
  storeName = "",
  storeNumber = "",
  onTemplateSelect = () => {},
}) => {
  const services = [JUNE_SO];
  const { trackEvent } = useAnalyticsActionEvents(services);
  const { currentUserData: { company = {} } = {} } = useCurrentUserContext();
  const { id: groupId, name: companyName } = company || {};
  const { workspaceSlug } = useWorkspaceContext();
  const handleUseTemplateClick = (e) => {
    stopEventPropagation(e);
    pageName &&
      trackEvent({
        eventName: getEventName({
          pageName,
          target: USE_TEMPLATE,
          action: "clicked",
        }),
        eventProperties: {
          shop_name: storeName,
          shop_number: storeNumber,
        },
        context: { groupId },
        additionalProps: { companyName },
      });
    onTemplateSelect(getCreateNewShopRoute({ shopNumber: storeNumber, workspaceSlug }));
  };

  return (
    <Button
      styleType="link"
      className={className}
      onClick={handleUseTemplateClick}
      title="USE TEMPLATE"
    >
      USE TEMPLATE
    </Button>
  );
};

export default UseTemplateCTA;
